import { X } from "lucide-react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "../../../shared/ui";
import { FlagTargetKind } from "./kybShowReviewShared";

type KybComplianceFlagRequirementModalProps = {
  open: boolean;
  flagReason: string;
  flagTargetKind: FlagTargetKind;
  isSubmitting: boolean;
  onOpenChange: (open: boolean) => void;
  onFlagReasonChange: (reason: string) => void;
  onSubmit: () => void;
};

const KybComplianceFlagRequirementModal = ({
  open,
  flagReason,
  flagTargetKind,
  isSubmitting,
  onOpenChange,
  onFlagReasonChange,
  onSubmit,
}: KybComplianceFlagRequirementModalProps) => {
  const flagModalTitle =
    flagTargetKind === "information" ? "Flag information" : "Flag document";
  const flagModalPrompt =
    flagTargetKind === "information"
      ? "What's wrong with this information?"
      : "What's wrong with this document?";

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      overlayClassName="bg-black/75"
      contentClassName="max-w-[600px] bg-white"
    >
      <ModalHeader className="items-center aku-heading-h2-semibold">
        <ModalTitle>{flagModalTitle}</ModalTitle>
        <button
          type="button"
          aria-label="Close modal"
          disabled={isSubmitting}
          onClick={() => onOpenChange(false)}
          className="rounded-full p-2 text-[#737AA8] hover:bg-[#F2F4FF] disabled:cursor-not-allowed disabled:opacity-50"
        >
          <X size={20} />
        </button>
      </ModalHeader>

      <ModalBody className="pt-4">
        <div
          id="kyb-requirement-flag-reason-label"
          className="aku-body-small-medium text-[#2C2F44]"
        >
          {flagModalPrompt}
        </div>
        <textarea
          id="kyb-requirement-flag-reason"
          aria-labelledby="kyb-requirement-flag-reason-label"
          value={flagReason}
          maxLength={100}
          disabled={isSubmitting}
          onChange={(event) => onFlagReasonChange(event.target.value)}
          placeholder="Enter a reason"
          className="mt-2 min-h-[120px] w-full resize-none rounded-[14px] bg-[#EEF1FB] px-4 py-3 text-[14px] font-[350] text-gray-30 placeholder:text-gray-20 focus:outline-none focus:ring-2 focus:ring-[#D9DEFF] disabled:cursor-not-allowed disabled:opacity-60"
        />
        <div className="mt-2 text-right text-[14px] font-[350] text-[#383B56]">
          {flagReason.length}/100
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          type="button"
          disabled={!flagReason.trim() || isSubmitting}
          onClick={onSubmit}
          className="h-11 rounded-[14px] px-6 text-[16px] font-[500]"
        >
          {isSubmitting ? "Flagging..." : flagModalTitle}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default KybComplianceFlagRequirementModal;
